module.exports = __webpack_public_path__ + "static/media/the_pepsico_way.afed49ce.png";